/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';

import CtaCard from 'components/shared/cta-card/cta-card';

const News = ({ data }) => {
  const isAnimate = data.animate;
  useEffect(() => {
    if (data.animate) {
      sal({ threshold: 0.25 });
    }
  }, [data.animate]);

  return (
    <div>
      {data.related_news && (
        <div className="container mb-7 pt-7 lg:mb-8 lg:pt-8 xl:mb-10 xl:pt-10">
          <h3 className="mb-14 font-heading text-sm uppercase lg:col-span-2 lg:mb-16 lg:text-xl xl:mb-20 xl:text-2.5xl">
            Related Articles
          </h3>
          <div className="grid grid-cols-2 gap-5 lg:grid-cols-3 xl:gap-5">
            {data.related_news.map((news, idx) => {
              let gridClass = 'col-span-1';
              if (idx === 0) {
                gridClass = 'col-span-2 lg:col-span-1';
              }

              return (
                <div key={news.uuid} className={gridClass}>
                  <CtaCard
                    data={news.content}
                    aspectRatioClass="aspect-[520/320]"
                    mediaWrapperClass="!overflow-visible !flex-none"
                    slug={news.full_slug}
                    isAnimated={isAnimate}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default News;

News.propTypes = {
  data: PropTypes.object.isRequired,
};
